import Vue from 'vue'
import Vuex from 'vuex'

import sessao from './sessao'
import login from './login'

Vue.use(Vuex)

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

export default function (/* { ssrContext } */) {
  const store = new Vuex.Store({
    modules: {
      sessao,
      login
    },
    strict: process.env.DEV
  })

  return store
}
